import { z } from "zod"

export const PRODUCT_VISUAL_DISPATCH_CLASS = {
  urgent: "urgent",
  automatic: "automatic",
  background: "background",
} as const
export const productVisualDispatchClassSchema = z.enum(PRODUCT_VISUAL_DISPATCH_CLASS)
export type ProductVisualDispatchClass = z.infer<typeof productVisualDispatchClassSchema>
export const productVisualPrioritySchema = z.enum(["urgent", "background"])
export type ProductVisualPriority = z.infer<typeof productVisualPrioritySchema>

export const PRODUCT_VISUAL_DISPATCH_RESULT = {
  started: "started",
  capacityWait: "capacity_wait",
  priorityWait: "priority_wait",
  disabled: "disabled",
  empty: "empty",
  unavailable: "launcher_unavailable",
  rejected: "rejected",
  launchUncertain: "launch_uncertain",
  superseded: "superseded",
  reattached: "reattached",
  retryWait: "retry_wait",
} as const

export const productVisualDispatchAttemptSchema = z
  .object({
    selectedClass: productVisualDispatchClassSchema,
    result: z.enum(PRODUCT_VISUAL_DISPATCH_RESULT),
    replacementId: z.string().nullable(),
    planId: z.string().nullable(),
    renderJobId: z.string().nullable(),
  })
  .strict()
export type ProductVisualDispatchAttempt = z.infer<typeof productVisualDispatchAttemptSchema>

export const productVisualDispatchEvidenceSchema = z
  .object({
    version: z.literal(1),
    nextSharedClass: z.enum(["automatic", "background"]),
    legacyUrgentBacklog: z.number().int().nonnegative(),
    attempts: z.array(productVisualDispatchAttemptSchema).max(6),
  })
  .strict()
export type ProductVisualDispatchEvidence = z.infer<typeof productVisualDispatchEvidenceSchema>
